module.exports = __webpack_public_path__ + "img/family_icon.67bcc07d.png";